import React from "react";
import Navbar from "../HomePage/Navbar/Navbar";
import NavbarD from "../HomePage/Navbar/NavbarD";
import Footer from "../HomePage/Footer/Footer";
import termsDataEn from "../../languages/en/termsData";
import termsDataTh from "../../languages/th/termsData";
import { useLanguage } from "../../context/LanguageContext";

const TermsAndConditionsPage = () => {
  const { selectedLanguage } = useLanguage(); // Use the context
  console.log(selectedLanguage);
  const termsData = selectedLanguage === "en" ? termsDataEn : termsDataTh;

  let currentNumber = 1;
  return (
    <>
      <div className="lg:hidden">
        <Navbar theme="black" />
      </div>
      <div className="hidden md:hidden lg:block">
        <NavbarD theme="black" />
      </div>

      <h1 className="text-3xl text-center font-bold my-10 px-4">
        {termsData.title}
      </h1>

      <div className="px-4" id="terms">
        <p className=" text-xs ">{termsData.subTitle}</p>

        <h3 className="text-xl font-bold mt-3">{termsData.heading}</h3>

        <h4 className="text-lg font-medium mt-4">{termsData.subHeading}</h4>
        <p className="mt-2">{termsData.paragraph}</p>
      </div>
      <div className="p-4">
        {termsData.data.map(
          (term) => (
            (currentNumber = 1),
            (
              <div key={term.id} className="my-4">
                {term.id ? (
                  <div className="font-bold text-lg">{`${term.id}. ${term.title}`}</div>
                ) : (
                  <div className="font-bold text-lg">{term.title}</div>
                )}
                {term.description.length > 1 ? (
                  term.description.map((item, index) => (
                    <div key={index} className="pl-6">
                      {`${
                        term.id ? `${term.id}.${currentNumber}` : currentNumber
                      }. ${item}`}
                      {currentNumber++}
                    </div>
                  ))
                ) : (
                  <div className="pl-2">{term.description[0]}</div>
                )}
              </div>
            )
          )
        )}
      </div>

      <Footer language={selectedLanguage} />
    </>
  );
};

export default TermsAndConditionsPage;
